"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpInsurerDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_rfp_details_entry_entity_1 = require("./opportunity-rfp-details-entry.entity");
const look_up_entity_1 = require("./look-up.entity");
const city_entity_1 = require("./city.entity");
const insurer_contact_entity_1 = require("./insurer-contact.entity");
let OpportunityRfpInsurerDetail = class OpportunityRfpInsurerDetail {
};
exports.OpportunityRfpInsurerDetail = OpportunityRfpInsurerDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_id", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "insurer_location_id",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "locationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "insurer_branch",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "branchId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "insurer_contact_id",
        type: "integer",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "contactId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "preference_type_lid", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "preferenceTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityRfpInsurerDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityRfpInsurerDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityRfpInsurerDetail.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "integer", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "opportunity_rfp_details_entry_id",
        type: "integer",
        nullable: false,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpInsurerDetail.prototype, "opportunityRfpDetailsEntryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_rfp_details_entry_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry !== "undefined" && opportunity_rfp_details_entry_entity_1.OpportunityRfpDetailsEntry) === "function" ? _d : Object)
], OpportunityRfpInsurerDetail.prototype, "opportunityRfpDetailsEntry", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "preference_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], OpportunityRfpInsurerDetail.prototype, "preferenceType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => city_entity_1.City),
    (0, typeorm_1.JoinColumn)({ name: "insurer_location_id", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], OpportunityRfpInsurerDetail.prototype, "location", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_contact_entity_1.InsureContact, (insurerContact) => insurerContact.insurer, {
        eager: true,
    }),
    (0, typeorm_1.JoinColumn)({ name: "insurer_id", referencedColumnName: "insurerId" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], OpportunityRfpInsurerDetail.prototype, "insurerContact", void 0);
exports.OpportunityRfpInsurerDetail = OpportunityRfpInsurerDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_rfp_insurer_detail" })
], OpportunityRfpInsurerDetail);
